import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./user-bubbles.css";

const UserBubbles = ({ engagementUsers }) => {
	const [hoveredIndex, setHoveredIndex] = useState(null);
	const [cardPosition, setCardPosition] = useState({ top: 0, left: 0 });

	if (!engagementUsers || engagementUsers.length === 0) {
		return "No Assigned Users";
	}

	const handleMouseEnter = (index, event) => {
		const rect = event.currentTarget.getBoundingClientRect();
		setCardPosition({ top: rect.bottom, left: rect.left });
		setHoveredIndex(index);
	};

	const handleMouseLeave = () => {
		setHoveredIndex(null);
	};

	return (
		<div className="user-bubbles">
			{engagementUsers.map((eu, index) => {
				let engagementUser = eu.User;
				let userRole = eu.Role;

				if (!engagementUser || !userRole) {
					return null;
				}

				let initials = `${engagementUser.first_name[0]}${engagementUser.last_name[0]}`;
				let name = `${engagementUser.first_name} ${engagementUser.last_name}`;

				return (
					<div className="user-bubbles__item" key={`${index}-${eu.User}`} onMouseEnter={(e) => handleMouseEnter(index, e)} onMouseLeave={handleMouseLeave}>
						{initials}
						{hoveredIndex === index &&
							ReactDOM.createPortal(
								<div
									className="user-bubbles__item__card"
									style={{ top: cardPosition.top, left: cardPosition.left }}
								>
									<div className="user-bubbles__item__card__initials">{initials}</div>
									<div className="user-bubbles__item__card__details">
										<div className="user-bubbles__item__card__details__name">{name}</div>
										<div className="user-bubbles__item__card__details__role">{userRole.name}</div>
									</div>
								</div>,
								document.body,
							)}
					</div>
				);
			})}
		</div>
	);
};

export default UserBubbles;
